module.exports = __webpack_public_path__ + "media/images/third_party_logos/Bloomberg-2c165f9c143b60fe387eeb5192b1b9de.png";